import React, { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { useLang } from "../i18n";
import { PROCESS } from "../data/content";
import { SectionHeading } from "../components/SectionHeading";

export const Process = () => {
  const { lang, L } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 65%", "end 60%"] });
  const height = useSpring(scrollYProgress, { stiffness: 80, damping: 20 });

  return (
    <section className="relative bg-surface1/40 py-24 md:py-32">
      <div className="container-pdr">
        <SectionHeading
          label={lang === "ro" ? "Cum lucrăm" : "How we work"}
          title={lang === "ro" ? "Un proces clar, de la idee la punere în funcțiune." : "A clear process, from idea to commissioning."}
        />

        <div ref={ref} className="relative mt-16 pl-2">
          {/* rail */}
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-white/10 md:left-[23px]" />
          <motion.div
            style={{ scaleY: height }}
            className="absolute left-[19px] top-2 bottom-2 w-px origin-top bg-gradient-to-b from-glow-3 via-glow-2 to-brand shadow-[0_0_12px_1px_rgba(112,214,255,0.7)] md:left-[23px]"
          />

          <div className="space-y-10">
            {PROCESS.map((p, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: 30 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className="relative flex items-start gap-6 pl-12 md:pl-16"
                data-testid={`process-step-${i}`}
              >
                <span className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-full border border-glow-2/40 bg-ink font-mono text-sm font-semibold text-glow-2 md:h-12 md:w-12">
                  {i + 1}
                </span>
                <div className="pt-1">
                  <h3 className="font-display text-xl font-bold text-white md:text-2xl">{L(p)?.title}</h3>
                  <p className="mt-2 max-w-xl text-sm leading-relaxed text-white/55">{L(p)?.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
